<div class="form-page-layout">
  @if (config?.loading) {
    <div class="form-page-layout-loading">
      <app-loading-spinner
        [config]="loadingSpinnerConfig"
        trackingId="page-loading-spinner"
      />
    </div>
  }

  @if (content) {
    <div
      class="form-page-layout-content"
      [class.display-hidden]="config?.loading"
      data-ua-id="page-content"
    >
      <ng-container [ngTemplateOutlet]="content"></ng-container>
    </div>
  }

  @if (input) {
    <div
      class="form-page-layout-input"
      [class.display-hidden]="config?.loading"
      data-ua-id="page-input"
    >
      <ng-container [ngTemplateOutlet]="input"></ng-container>
    </div>
  }

  @if (action) {
    <div
      class="form-page-layout-action "
      [class.display-hidden]="config?.loading"
      data-ua-id="page-action"
    >
      <ng-container [ngTemplateOutlet]="action"></ng-container>
    </div>
  }
</div>
